import {HttpClient, HttpHandler} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';

@Injectable()

export class PaymentApi extends HttpClient {
    private baseUrl = environment.production ? "/channel-virtual/api/v1" + '/response' : environment.baseUrl + '/response';

    public constructor(handler: HttpHandler) {
      super(handler);
    }

    public returnToMerchant(sessionToken, userCancelled?): Observable<any> {
      let url = '';
      if (userCancelled) {
        url = `${this.baseUrl}/postback/${sessionToken}${userCancelled}`;
      } else {
        url = `${this.baseUrl}/postback/${sessionToken}`;
      }
      return super.post(url, '');
    }

}
